(() => {
  const dialog = document.querySelector('[data-catalogue-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const triggers = Array.from(document.querySelectorAll('[data-catalogue-trigger]'));
  const closeButton = dialog.querySelector('[data-catalogue-close]');
  let activeTrigger = null;
  let closeTimer;

  const setExpandedState = (expanded) => {
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', String(expanded)));
  };

  const finishClose = () => {
    if (!dialog.open || dialog.dataset.closing !== 'true') return;
    window.clearTimeout(closeTimer);
    dialog.close();
    delete dialog.dataset.closing;
    setExpandedState(false);
    const focusTarget = activeTrigger;
    activeTrigger = null;
    window.requestAnimationFrame(() => focusTarget?.focus());
  };

  const closeDialog = () => {
    if (!dialog.open || dialog.dataset.closing === 'true') return;
    dialog.dataset.closing = 'true';
    closeTimer = window.setTimeout(finishClose, 280);
  };

  const openDialog = (trigger = null) => {
    if (dialog.open) return;
    activeTrigger = trigger;
    delete dialog.dataset.closing;
    dialog.showModal();
    setExpandedState(true);

    window.requestAnimationFrame(() => {
      const status = dialog.querySelector('[data-catalogue-reopen]');
      const firstField = dialog.querySelector('[autofocus]');
      (status || firstField || closeButton)?.focus();
    });
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-catalogue-trigger]');
    if (trigger) {
      event.preventDefault();
      openDialog(trigger);
      return;
    }

    if (event.target.closest('[data-catalogue-close]')) closeDialog();
  });

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeDialog();
  });

  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (
      event.clientX < bounds.left ||
      event.clientX > bounds.right ||
      event.clientY < bounds.top ||
      event.clientY > bounds.bottom
    ) {
      closeDialog();
    }
  });

  dialog.addEventListener('animationend', (event) => {
    if (event.target === dialog && dialog.dataset.closing === 'true') finishClose();
  });

  if (dialog.querySelector('[data-catalogue-reopen]')) openDialog();
})();
